import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';
import type { MetricsExit } from '@/services/dynamicFlowsService';
import { formatNumber } from './format';

export function ExitsTable({ exits }: { exits: MetricsExit[] }) {
  useLanguage();
  return (
    <section className="flex min-w-0 flex-[1_1_300px] flex-col gap-3 rounded-2xl border border-[#D9E0EA] bg-white p-[18px]">
      <h2 className="text-[15px] font-bold text-[#111827]">{translateInterfaceText("Por saída")}</h2>
      {exits.length === 0 ? (
        <p className="text-sm text-[#4B5563]">{translateInterfaceText("O fluxo ainda não tem saídas.")}</p>
      ) : (
        <ul className="flex flex-col gap-2.5">
          {exits.map((exit) => (
            <li
              key={exit.exit_id}
              className={cn(
                'flex flex-wrap items-center justify-between gap-3 rounded-xl border p-3',
                exit.is_checkout ? 'border-[#BFD3FF] bg-[#F5F8FF]' : 'border-[#E5E7EB]',
              )}
            >
              <div className="flex min-w-0 flex-col gap-0.5">
                <span className="truncate text-sm font-semibold text-[#111827]">{exit.label}</span>
                <span
                  className={cn(
                    'text-xs',
                    exit.is_checkout ? 'font-semibold text-[#1E3A8A]' : 'text-[#4B5563]',
                  )}
                >
                  {exit.is_checkout ? translateInterfaceText("Checkout") : translateInterfaceText("Página externa")}
                </span>
              </div>
              <div className="flex flex-wrap justify-end gap-4 text-right text-xs text-[#4B5563]">
                <div>{exit.is_checkout ? translateInterfaceText("Acessos únicos ao checkout") : translateInterfaceText("Acessos únicos")}<strong className="block text-lg text-[#111827]">{formatNumber(exit.clicks)}</strong></div>
                {exit.is_checkout && <>
                  <div>{translateInterfaceText("Vendas aprovadas")}<strong className="block text-lg text-[#111827]">{exit.approved_sales == null ? '—' : formatNumber(exit.approved_sales)}</strong></div>
                  <div>{translateInterfaceText("Receita atribuída")}<strong className="block text-lg text-[#111827]">{exit.revenue == null ? '—' : new Intl.NumberFormat(getInterfaceLanguage(), { style: 'currency', currency: 'BRL' }).format(exit.revenue)}</strong></div>
                </>}
              </div>
            </li>
          ))}
        </ul>
      )}
      <span className="text-xs leading-relaxed text-[#6B7280]">
        {translateInterfaceText("Uma vez por sessão em cada saída. Atualiza a cada minuto.")}</span>
    </section>
  );
}
